module.exports = __webpack_public_path__ + "static/media/recommendations.10cbb527.svg";